<template>
    <div class="container">
        <div class="row">
            <div class="col-md-12">
                <div class="error-template">
                    <p class="error-line-a-heading">
                        {{$t(subheadingLocale)}}
                    </p>

                    <h1 class="error-code-heading">
                        {{errorCode}} <br>
                        {{$t(headingLocale)}}
                    </h1>

                    <div class="error-details mt-4">
                        <p>
                            {{$t(messageLocale)}}
                        </p>
                    </div>

                    <div v-if="showButton"
                        class="error-actions button-group button-group--responsive responsive--center-s">
                        <router-link
                            v-if="$route.path !== '/'"
                            :to="localeRoute('home')"
                            class="button success--button button--l">
                            {{$t("errorLayout.home_button")}}
                        </router-link>
                        <a :href="homePath"
                            v-else
                            class="button success--button button--l">
                            {{$t("errorLayout.home_button")}}
                        </a>

                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        errorCode: {
            type: String,
            default: '404'
        },
        subheadingLocale: {
            type: String,
            default: 'errorLayout.subheading_a'
        },
        headingLocale: {
            type: String,
            default: 'errorLayout.heading_404'
        },
        messageLocale: {
            type: String,
            default: 'errorLayout.error_message_404'
        },
        showButton: {
            type: Boolean,
            default: true
        }
    }
}

</script>

<style scoped>
.error-template {
    padding: 40px 15px;
    text-align: center;
}

.error-actions {
    margin-top:15px;
    margin-bottom:15px;
}

.error-footer {
    position: relative;
}

.error-code-heading {
    font-size: 50px;
}

.error-line-a-heading {
    font-size: 45px;
}

.error-details {
    font-size: 20px;
}
</style>